import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  fetchTree,
  listCatalog,
  findById,
  deleteCatalog,
  updateCatalog,
  fetchPartnerCatalogTree,
  fetchTenantCatalogTree,
  setExternalAttribute,
  createCatalogService,
  findByProviderIdCatalog,
  updateOrderAtribute,
  fetchTenantData
} from "@/services/catalog";

import {
  createLibrary,
  updateLibrary,
  listLibrary,
  deleteLibrary,
  detailLibrary
} from "@/services/imagegallery";

@Module({
  namespaced: true
})
export default class Catalog extends VuexModule {
  // state
  public catalogTree = [];
  public catalogList = [];
  public tenantCatalogList = [];
  public partnerCatalogList = [];
  public generatedTree = [];
  public imageLibraryList = [];

  public currentReadCatalog = {};

  // actions

  @Action
  public async resetCatalogState() {
    this.context.commit("resetState");
  }
  
  @Action
  public async fetchTenantData(payload) {
    try {
      const data = await fetchTenantData(payload);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createImageLibrary(payload) {
    try {
      const data = await createLibrary(payload);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateOrderAtributeAction(payload) {
    try {
      const data = await updateOrderAtribute(payload);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateImageLibrary(payload) {
    try {
      const data = await updateLibrary(payload);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async listImageLibrary(payload) {
    try {
      const data = await listLibrary(payload);
      this.context.commit("setImageLibraryList", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async deleteImageLibrary(payload) {
    try {
      const data = await deleteLibrary(payload);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getImageLibraryById(payload) {
    try {
      const data = await detailLibrary(payload);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateCatalogTree(payload) {
    try {
      this.context.commit("setGeneratedTree", payload);
      return payload;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchCatalogTree() {
    try {
      const data = await fetchTree();
      this.context.commit("setCatalogTree", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTenantCatalogTree() {
    try {
      const data = await fetchTenantCatalogTree();
      this.context.commit("setTenantCatalogTree", data.response);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerCatalogTree() {
    try {
      const data = await fetchPartnerCatalogTree();
      this.context.commit("setPartnerCatalogTree", data.response);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchCatalogById(payload) {
    try {
      const data = await findById(payload);
      this.context.commit("setCurrentReadCatalog", data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchCatalogList(params) {
    try {
      let searchQuery = params ? params : "";
      const data = await listCatalog(searchQuery);
      this.context.commit("setCatalogList", data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createCatalogService(payload) {
    try {
      const data = await createCatalogService(payload);
      this.context.dispatch("fetchCatalogList");
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async findCatalogByProviderId(payload) {
    try {
      const data = await findByProviderIdCatalog(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async setExternalAttribute(payload) {
    try {
      const data = await setExternalAttribute(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async deleteCatalog(payload) {
    try {
      const data = await deleteCatalog(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateCatalog(payload) {
    try {
      const data = await updateCatalog(payload._id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  // mutations
  @Mutation
  public resetState() {
    this.catalogTree = [];
    this.catalogList = [];
    this.tenantCatalogList = [];
    this.partnerCatalogList = [];
    this.generatedTree = [];
    this.imageLibraryList = [];
    this.currentReadCatalog = {};
  }

  @Mutation
  public setImageLibraryList(data: any) {
    this.imageLibraryList = data;
  }

  @Mutation
  public setGeneratedTree(data: any) {
    this.generatedTree = data;
  }

  @Mutation
  public setCatalogTree(data: any) {
    this.catalogTree = data;
  }

  @Mutation
  public setTenantCatalogTree(data: any) {
    this.tenantCatalogList = data;
  }

  @Mutation
  public setPartnerCatalogTree(data: any) {
    this.partnerCatalogList = data;
  }

  @Mutation
  public setCatalogList(data: any) {
    this.catalogList = data;
  }

  @Mutation
  public setCurrentReadCatalog(data: any) {
    this.currentReadCatalog = data;
  }

  // getters
  get GetCatalogTree() {
    return this.catalogTree;
  }

  get GetTenantCatalogTree() {
    return this.tenantCatalogList;
  }

  get GetPartnerCatalogTree() {
    return this.partnerCatalogList;
  }

  get GetCurrentReadCatalog() {
    return this.currentReadCatalog;
  }

  get GetGeneratedCatalog() {
    return this.generatedTree;
  }

  get GetImageLibraryList() {
    return this.imageLibraryList;
  }

  get GetCategoryList() {
    return this.catalogList;
  }
}
